import { render } from "./shopVue.vue?vue&type=template&id=544e8aff"
import script from "./shopVue.vue?vue&type=script&lang=js"
export * from "./shopVue.vue?vue&type=script&lang=js"

import "../assets/css/shops.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__